.xm-checkbox-list {
  display: block;
  width: 100%;

  .ant-listy {
    width: 100%;
    --rc-virtual-list-scrollbar-bg: var(--ant-color-split);
  }

  // keep the indentation the plain checkbox lists had
  .ant-listy-item {
    padding-inline: 1em 0.5em;
  }
}